import { useMemo } from "react";
import { NavMain } from "@/components/nav-main";
import { SidebarTrialBanner } from "@/components/sidebar-trial-banner";
import { Sidebar, SidebarContent } from "@/components/ui/sidebar";
import {
  getNavigationSectionsForRole,
  type NavigationSection,
} from "@/constants/navigation";
import { useUser } from "@/lib/user-context";

export function AppSidebar(props: React.ComponentProps<typeof Sidebar>) {
  const { systemRole } = useUser();
  const navigationSections = useMemo<readonly NavigationSection[]>(
    () => (systemRole ? getNavigationSectionsForRole(systemRole) : []),
    [systemRole]
  );

  return (
    <Sidebar
      style={
        {
          top: "3.5rem",
          height: "calc(100svh - 3.5rem)",
        } as React.CSSProperties
      }
      {...props}
    >
      <SidebarContent>
        {navigationSections.map((section, index) => (
          <NavMain
            key={section.label ?? `primary-${index}`}
            label={section.label}
            items={section.items.map(({ to, label, icon, subItems }) => ({
              title:
                typeof label === "string"
                  ? label
                  : ((systemRole ? label[systemRole] : undefined) ?? "View"),
              url: to,
              icon,
              subItems: subItems?.map((subItem) => ({
                title:
                  typeof subItem.label === "string"
                    ? subItem.label
                    : ((systemRole ? subItem.label[systemRole] : undefined) ??
                      "View"),
                url: subItem.to,
                end: subItem.end,
              })),
            }))}
          />
        ))}
      </SidebarContent>
      <SidebarTrialBanner />
    </Sidebar>
  );
}
